/** Запуск видео внутри контейнера */
export function playVideo(containerNode: HTMLElement) {
    const [videoNode] = containerNode.getElementsByTagName('video');

    // Необходимо вручную запускать видео
    // https://voximplant.com/docs/guides/calls/weberrors#autoplay-policies-in-browsers
    if (videoNode) videoNode.play();
}
